/* eslint-disable */

import { AddOn } from './AddOn';
//import * as wording from '../../../common/js/wording'
import { AddOnType } from '../FbbEnum';
import * as log from '../../../common/js/appLogger';

/*
Pls submit “Z,1” for equipList plus below values (like Norton):

WiFi路由器	VAS Code	標準月費	Mktg code	收費總額	合約期(月)	合約代號	T&C
Asus RT-AC68U	FBRM1	$40	MVZ08	$960	24	LDJ24M40	N003PB
*/
export class AddOnRentalMeshRouter extends AddOn {
	static readonly codesInfo = [
		{
			amount: 1,
			ignorePlanCode: true,
			planCodeAllowed: ['all'],
			code: 'MESH-RENTALX1',
		},
		/***
        {
            "amount" : 2,
            "ignorePlanCode" : true,
            "planCodeAllowed" : ["all"],
            "code" : "MESH-RENTALX2"                    
        },  
        /****/
	];

	//protected baseVasCode:String = 'ROUTER-RENTAL-MESH-RENTALX2';   // general for reference
	protected boxAmount2: number = 0;

	constructor() {
		super();
		this.key = 'AddOnRentalMeshRouter';

		this.boxIconEn = '';
		this.boxIconZh = '';
		this.boxNameEn = 'Mesh Router Rental';
		this.boxNameZh = 'Mesh Router Rental';
		this.boxAmount = 48; // per month    for 6 / 12mth contract
		this.boxAmount2 = 28; // per month    for 24 / 30mth contract
		this.discountAmount = -1; // 3080
		this.boxCount = 0;
		this.hasRedCounter = false;

		this.type = AddOnType.SINGLE;
	}

	public isAddOnSelected(): boolean {
		return this.boxCount > 0;
	}

	//=================================================================================
	/** no overwrite AddOn one 
    public getData() : any {
        //var data = super.getData()
        return data
    }
    public parse(data: any) {
        //super.parse(data)
    }
    */
	//=================================================================================

	public getPlanVasCode2(amount: Number, planCode: string): string {
		let vasCode;
		if (this.isAddOnSelected()) {
			let option = null;
			for (var i = 0; i < AddOnRentalMeshRouter.codesInfo.length; i++) {
				if (AddOnRentalMeshRouter.codesInfo[i].amount == amount) {
					if ((AddOnRentalMeshRouter.codesInfo[i].ignorePlanCode ?? false) == true) {
						option = AddOnRentalMeshRouter.codesInfo[i];
						break;
					} else {
						if (AddOnRentalMeshRouter.codesInfo[i].planCodeAllowed.indexOf(planCode) > -1) {
							option = AddOnRentalMeshRouter.codesInfo[i];
							break;
						}
					}
				}
			}

			vasCode = option?.code ?? '';
			return vasCode;
		} else {
			return '';
		}
	}

	// overwrite AddOn.ts one
	public getAmount(contractMonth: String | null): Number {
		let avgPrice = this.boxAmount;
		if (['6', '12'].indexOf(contractMonth + '') > -1) {
			avgPrice = this.boxAmount;
		} else if (['24', '30'].indexOf(contractMonth + '') > -1) {
			avgPrice = this.boxAmount2;
		}
		return avgPrice;
	}
}
